module.exports = __webpack_public_path__ + "static/Karthic-Rao-55d7b4a8d795e4cd6ce965101774109d.jpg";